import { SearchPayee } from '../model/tsp.types'

export const getTspSearchItemHref = (item: SearchPayee) => {
  if (item.features?.platform_type === 'business') {
    return `https://payment.mts.ru/tools/${item.features?.tsp_url ?? ''}`
  }

  return `/${item.features?.tsp_url ?? ''}`
}
